/**
 * PackRelatedStrip — Toile's port of narcis's/ovid's own `packs/PackRelatedStrip.tsx` (pack page
 * canon convergence). Presentation only: card data (`relatedTitle`/`relatedPacksCards`, resolved by
 * `relatedPacks.ts` against `catalog.ts`'s `getCatalogCards()`) is built server-side in the route
 * loader and passed in fully formed.
 *
 * Toile drops narcis's `showWearAction` — the D-state "Wear this →" affordance has no Toile
 * counterpart (no generation on this surface) — everything else, including the empty-cards guard,
 * is the same component.
 */
import {Link} from 'react-router'
import styles from './PackRelatedStrip.module.scss'

export interface PackRelatedCard {
    slug: string
    title: string
    cover: string
    /** Pre-formatted meta line — e.g. "9 samples · coloring". */
    meta: string
}

interface PackRelatedStripProps {
    title: string
    linkLabel: string
    linkHref: string
    cards: PackRelatedCard[]
}

export function PackRelatedStrip({title, linkLabel, linkHref, cards}: PackRelatedStripProps) {
    if (cards.length === 0) return null
    return (
        <section className={styles.rel} aria-label="Related packs">
            <div className={styles.relHead}>
                <h2 className={styles.relTitle}>{title}</h2>
                <Link to={linkHref} className={styles.relLink}>{linkLabel}</Link>
            </div>
            <div className={styles.relGrid}>
                {cards.map((card) => (
                    <Link key={card.slug} to={`/${card.slug}`} className={styles.relCard}>
                        <span className={styles.relCardPh}>
                            <img src={card.cover} alt="" loading="lazy" className={styles.relCardImg} />
                        </span>
                        <span className={styles.relCardTitle}>
                            {card.title}
                            <i className={styles.relCardMeta}>{card.meta}</i>
                        </span>
                    </Link>
                ))}
            </div>
        </section>
    )
}
